import { Controller } from '@hotwired/stimulus';
import { SwitchController } from '@elc-online/edl-components/js/switch';

export type SwitchEventDetails = { isChecked: boolean };

export default class extends Controller {
  static readonly targets = ['button'];

  declare buttonTarget: HTMLButtonElement;

  private edlController: SwitchController;

  private switchUnsubscribe?: () => void;

  initialize(): void {
    this.edlController = new SwitchController(
      {
        button: this.buttonTarget,
      },
      { mode: 'auto' },
    );
  }

  connect(): void {
    this.switchUnsubscribe = this.edlController.subscribe(() => {
      const isChecked = this.edlController.checked;
      const event = new CustomEvent<SwitchEventDetails>('on_switch_toggle', { 
        detail: { isChecked }
      });
      this.buttonTarget.dispatchEvent(event);
    });
  }

  disconnect(): void {
    this.switchUnsubscribe?.();
  }
}
